import { render, staticRenderFns } from "./OrderDetailPaymentInfo.vue?vue&type=template&id=e0d50a60&scoped=true&"
import script from "./OrderDetailPaymentInfo.vue?vue&type=script&lang=js&"
export * from "./OrderDetailPaymentInfo.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailPaymentInfo.vue?vue&type=style&index=0&id=e0d50a60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d50a60",
  null
  
)

export default component.exports